import { IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import {
  MONTHLY_EXPENSES_FORM_TYPES,
  monthlyExpansesFormType,
} from 'components/BusinessToolForm/Sections/FinancialPlan/PlannedExpenses/MonthlyExpensesForm/utils/form';
import { IGlobalProductEntity, PRODUCT_NAMES } from 'components/BusinessToolForm/Sections/Global/general/products';

export const createRequestBodyForMonthlyExpanses = (expanses: monthlyExpansesFormType, nonOperatingExpense: IPeriodsTableRow) => {
  const costOfSalesOfProducts = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.COST_OF_SALES_PRODUCTS,
    plannedMonthlyExpenses: Number(expanses.costOfSalesExpenses),
    annualExpenseGrowthRate: Number(expanses.costOfSalesGrowthRate),
  };

  const rAndD = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.RESEARCH_AND_DEVELOPMENT,
    plannedMonthlyExpenses: Number(expanses.randDExpenses),
    annualExpenseGrowthRate: Number(expanses.randDGrowthRate),
  };
  const salesAndMarketing = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.SALES_AND_MARKETING,
    plannedMonthlyExpenses: Number(expanses.salesAndMarketingExpenses),
    annualExpenseGrowthRate: Number(expanses.salesAndMarketingGrowthRate),
  };

  const generalAndAdministrative = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.GENERAL_AND_ADMINISTRATIVE,
    plannedMonthlyExpenses: Number(expanses.generalAndAdminExpenses),
    annualExpenseGrowthRate: Number(expanses.generalAndAdminGrowthRate),
  };
  const otherOperatingExpenses = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.OTHER_OPERATING_EXPENSES,
    plannedMonthlyExpenses: Number(expanses.otherOperatingExpenses),
    annualExpenseGrowthRate: Number(expanses.otherOperatingGrowthRate),
  };
  const financialExpenses = {
    companyExpenseType: MONTHLY_EXPENSES_FORM_TYPES.FINANCIAL_EXPENSES,
    plannedMonthlyExpenses: Number(expanses.financialExpenses),
    annualExpenseGrowthRate: Number(expanses.financialGrowthRate),
  };

  const expensesData = [
    costOfSalesOfProducts,
    rAndD,
    salesAndMarketing,
    generalAndAdministrative,
    otherOperatingExpenses,
    financialExpenses,
  ];

  return {
    generalExpenseData: expensesData,
    nonOperatingExpense
  };
};

export const getProductExpenses = (products: IGlobalProductEntity[]) => {
  return products.map((product) => {
    return {
      [PRODUCT_NAMES.PRODUCT_ID]: product[PRODUCT_NAMES.PRODUCT_ID],
      [PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH]: product[PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH],
      [PRODUCT_NAMES.COST_PER_UNIT]: product[PRODUCT_NAMES.COST_PER_UNIT],
    };
  });
};

export const getProductExpensesData = (products: IGlobalProductEntity[]) => {
  return products.map((product) => {
    return {
      [PRODUCT_NAMES.PRODUCT_ID]: product[PRODUCT_NAMES.PRODUCT_ID] ?? '',
      annualExpenseGrowthRate: Number(product[PRODUCT_NAMES.ANNUAL_EXPENSE_GROWTH]),
      variableExpenses: Number(product[PRODUCT_NAMES.COST_PER_UNIT]),
    };
  })
};
